import { render } from "./LovsManagementPreviewDialog.vue?vue&type=template&id=361aeffa&ts=true"
import script from "./LovsManagementPreviewDialog.vue?vue&type=script&lang=ts"
export * from "./LovsManagementPreviewDialog.vue?vue&type=script&lang=ts"

import "./LovsManagementPreviewDialog.vue?vue&type=style&index=0&id=361aeffa&lang=scss"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__